function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: "#1f2431",
  d: "M480.987,237V100.4a100.38,100.38,0,1,1,200.759,0V237H480.987Z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: "#1a4c47",
  d: "M480.9,385c0.052-1.567.088-3.137,0.088-4.716V237.4a100.38,100.38,0,1,1,200.759,0V380.284c0,1.576-.038,3.144-0.059,4.716H480.9Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: "#128867",
  d: "M596.927,605.1L444.959,474a139.615,139.615,0,0,0,36.028-93.719V379.4a100.38,100.38,0,1,1,200.759,0v0.882A339.594,339.594,0,0,1,596.927,605.1Z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  fill: "#0bc286",
  d: "M591.787,611.189c-2.048,2.247-4.213,4.385-6.456,6.439C523.346,681.372,436.668,721.25,340.875,721.25,152.916,721.25,0,568.291,0,380.284V100.4a100.379,100.379,0,1,1,200.759,0V380.284c0,77.28,62.855,140.152,140.115,140.152a139.7,139.7,0,0,0,101.343-43.482A100.489,100.489,0,1,1,591.787,611.189Z"
});

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 682,
    height: 722,
    viewBox: "0 0 682 722",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.073f3ca5.svg";
export { ForwardRef as ReactComponent };